import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { RegionStatusRow } from './blocks/RegionStatusRow'
import { AvatarStack, AvatarStackProps } from '../avatarStack/AvatarStack'
import { Badge } from '@app/components/core/badge/Badge'
import Row from '@app/components/layout/Row'
import { useQuery } from '@based/sdk/react'

const backgroundColors = [
  'var(--shades-yellow-100)',
  'var(--shades-pink-100)',
  'var(--shades-red-100)',
  'var(--shades-blue-50)',
]

export type RegionCardPros = {
  id: number
  title: string
  isCrowdbuildingPartner?: boolean
  subsidies?: number
  initiatives: number
  colorIndex?: number
  onClick?: () => void
} & Pick<AvatarStackProps, 'avatars'>

export const RegionCard = ({
  id,
  title,
  isCrowdbuildingPartner = false,
  subsidies,
  initiatives,
  avatars,
  colorIndex = 0,
  onClick,
}: RegionCardPros) => {
  const followerCountQuery = useQuery('count-followers', {
    entityType: 'region',
    entityIds: [id],
  })

  return (
    <Column
      gap="1.5rem"
      alignItems="stretch"
      onClick={onClick}
      style={{
        padding: '1rem',
        borderRadius: '1.25rem',
        backgroundColor: backgroundColors[colorIndex],
        minHeight: '10rem',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Column gap="0.5rem">
        <Row gap="0.5rem" style={{ alignItems: 'center', overflow: 'hidden', width: '100%' }}>
          <Title.H3
            style={{
              margin: 0,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {title}
          </Title.H3>
          {isCrowdbuildingPartner && <Badge />}
        </Row>

        <RegionStatusRow
          initiatives={initiatives}
          subsidies={subsidies}
          isLocked={!isCrowdbuildingPartner}
        />
      </Column>

      <AvatarStack
        size={'extra-small'}
        avatars={avatars}
        total={followerCountQuery.data?.[0] ?? 0}
      />
    </Column>
  )
}
